import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import Steps from 'antd/es/steps';
import { useTheme } from 'styled-components';
import { ReviewFormSteps } from '../../../../features/entities';
import useMediaQuery from '../../../../features/helpers/use-media-query';
import { useTranslations } from '../../../../features/providers/translations-provider';
const ReviewFormHeader = ({ rfpId, reviewStep, }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.tablet });
    if (rfpId || isTablet)
        return _jsx(_Fragment, {});
    return (_jsx("div", { style: { marginBottom: 24 }, children: _jsx(Steps, { style: {
                width: '100%',
            }, size: "small", current: reviewStep == ReviewFormSteps.Experience ? 0 : 1, items: [
                {
                    title: t('reviews|newReviewStepsStep1'),
                },
                {
                    title: t('reviews|newReviewStepsStep2'),
                },
            ] }) }));
};
export default ReviewFormHeader;
